/* unplugin-vue-components disabled */import script from "./plan_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./plan_copy.vue?vue&type=script&setup=true&lang=js"

import "./plan_copy.vue?vue&type=style&index=0&id=24709848&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24709848"]])

export default __exports__